import React, { useEffect, useRef } from 'react';

export default function CustomCursor() {
  const cursorRef = useRef(null);
  const coreRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const core = coreRef.current;

    if (!cursor || !core || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return undefined;
    }

    const handleMove = (event) => {
      const transformValue = `translate(${event.clientX}px, ${event.clientY}px)`;
      cursor.style.transform = transformValue;
      core.style.transform = transformValue;
    };

    const handleDown = () => cursor.classList.add('global-cursor--active');
    const handleUp = () => cursor.classList.remove('global-cursor--active');

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mousedown', handleDown);
    window.addEventListener('mouseup', handleUp);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mousedown', handleDown);
      window.removeEventListener('mouseup', handleUp);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className="global-cursor" aria-hidden="true" />
      <div ref={coreRef} className="global-cursor-core" aria-hidden="true" />
    </>
  );
}
